import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useScrollPositionStore = defineStore('scrollPosition', () => {
  const page = ref<string>('')
  const position = ref<number>(0)

  const setScrollPosition = (newPosition: number) => {
    position.value = newPosition
  }

  const setPage = (newPage: string) => {
    page.value = newPage
  }

  return {
    page,
    position,
    setScrollPosition,
    setPage,
  }
})
